import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NotFoundPublic: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/login");
  }, []);

  return <div></div>;
};

export default NotFoundPublic;
